<div class="ews-page">

  <!-- Filter bar -->
  <div class="filter-bar">
    <div class="f-burn">
      <rms-select name="ewsBurnRange" label="Burn range" [options]="BurnRangeOptions"
                  [(ngModel)]="Filters.BurnRange" (ngModelChange)="queueRefresh()" ></rms-select>
    </div>
    <div class="f-wh">
      <rms-select name="ewsWarehouse" label="Warehouse" [options]="WarehouseOptions"
                  [(ngModel)]="SelectedWarehouse" (ngModelChange)="queueRefresh()" ></rms-select>
    </div>
    <div class="f-safs">
      <rms-number name="ewsSafsValue" label="SAFS (growth)" [(ngModel)]="Filters.SafsValue" (ngModelChange)="queueRefresh()" min="0"
                  ></rms-number>
    </div>
    <div class="f-safs-type">
      <rms-select name="ewsSafsType" label="SAFS type" [options]="SafsTypeOptions"
                  [(ngModel)]="Filters.SafsType" (ngModelChange)="queueRefresh()" ></rms-select>
    </div>
    <div class="f-crop">
      <rms-select name="ewsCropOption" label="Crop" [options]="CropOptions"
                  [(ngModel)]="Filters.CropOption" (ngModelChange)="queueRefresh()" ></rms-select>
    </div>
    <div class="f-days">
      <rms-number name="ewsDaysInAdj" label="Days-in adj." [(ngModel)]="Filters.DaysInAdj" (ngModelChange)="queueRefresh()"
                  ></rms-number>
    </div>
    <div class="f-checks">
      <rms-checkbox name="ewsVolatile" [small]="true" label="Volatile market"
                    [(ngModel)]="Filters.VolatileMarket" (ngModelChange)="queueRefresh()" ></rms-checkbox>
      <rms-checkbox name="ewsFireSales" [small]="true" label="Exclude fire sales"
                    [(ngModel)]="Filters.ExcludeFireSales" (ngModelChange)="queueRefresh()" ></rms-checkbox>
      <rms-checkbox name="ewsInactive" [small]="true" label="Show inactive groups"
                    [(ngModel)]="Filters.IncludeInactive" (ngModelChange)="queueRefresh()" ></rms-checkbox>
    </div>
    <div class="f-run">
      <span class="run-hint" role="status">{{ Loading ? 'Updating…' : 'Live · updates automatically' }}@if (UpdatedAt) { · {{ UpdatedAt | date:'h:mm:ss a' }} }</span>
      <button mat-stroked-button (click)="run()" [disabled]="Loading"><mat-icon>refresh</mat-icon>Refresh</button>
    </div>
  </div>

  <!-- What the numbers are based on -->
  @if (RunInfo) {
  <div class="run-info" [class.test-mode]="RunInfo.IsTestMode">
    @if (RunInfo.IsTestMode) {
    <mat-icon>science</mat-icon>
    <span>
      <b>Test mode</b> — burn is measured up to {{ RunInfo.BurnWindowEnd | date:'MMM d, y':'UTC' }}
      (orders after that date aren't in RMS 2.0 yet). Stock and arrivals are as of today.
    </span>
    } @else {
    <mat-icon>info</mat-icon>
    }
    <span class="run-meta">
      Burn {{ RunInfo.BurnWindowStart | date:'MMM d, y':'UTC' }} – {{ RunInfo.BurnWindowEnd | date:'MMM d, y':'UTC' }}
      · {{ RunInfo.BurnRange }}-month average
      · SAFS {{ RunInfo.SafsValue }}{{ RunInfo.SafsType === 'PCT' ? '%' : ' bags' }}
      · {{ RunInfo.ForecastMonths }} months
      @if (IsSpotView) { · <b>Spot &amp; Transfer view</b> }
    </span>
  </div>
  }

  <!-- Coverage cards (click to filter) -->
  <div class="stat-cards">
    @for (card of CoverageCards; track card.label) {
    <div class="summary-card {{ card.cssClass }}"
         [class.active]="ActiveCoverage === card.status"
         (click)="selectCoverage(card)">
      <div class="summary-label">{{ card.label }}</div>
      <div class="summary-value">{{ countFor(card) }}</div>
    </div>
    }
  </div>

  <!-- Legend -->
  <div class="legend">
    <span><i class="sw sw-neg"></i>Short (closing bags below 0)</span>
    <span><i class="sw sw-low"></i>Less than one month's goal left</span>
    <span><i class="sw sw-crop"></i>New-crop month</span>
    <span class="hint">Month columns = projected bags left at month end. Months 13–24 can be turned on with "customize".</span>
  </div>

  <!-- rms-table needs its columns ready before it renders -->
  @if (Loaded) {
  <div class="ews-table">
    <rms-table [HeaderButtons]="Buttons"
               [parentContext]="this"
               [data]="FilteredRows"
               [columns]="Columns"
               tableId="ews-summary-main"
               [customizable]="true"
               [pageSize]="100">
    </rms-table>
  </div>
  } @else {
  <div class="loading">{{ Loading ? 'Running the forecast…' : 'No data.' }}</div>
  }

</div>
